module.exports = require("serialize-error");


//////////////////
// WEBPACK FOOTER
// external "serialize-error"
// module id = 137
// module chunks = 0